import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const HumidityMidIcon: React.FC<IconProps> = props => (
  <Icon fill="currentColor" {...props}>
    <path d="M12 21.5C9.78333 21.5 7.89583 20.7333 6.3375 19.2C4.77917 17.6667 4 15.8 4 13.6C4 12.55 4.20417 11.5458 4.6125 10.5875C5.02083 9.62917 5.6 8.78333 6.35 8.05L12 2.5L17.65 8.05C18.4 8.78333 18.9792 9.62917 19.3875 10.5875C19.7958 11.5458 20 12.55 20 13.6C20 15.8 19.2208 17.6667 17.6625 19.2C16.1042 20.7333 14.2167 21.5 12 21.5ZM6 13.6H18C18 12.8167 17.85 12.0708 17.55 11.3625C17.25 10.6542 16.8167 10.0333 16.25 9.5L12 5.3L7.75 9.5C7.18333 10.0333 6.75 10.6542 6.45 11.3625C6.15 12.0708 6 12.8167 6 13.6Z" />
  </Icon>
)
